if (!customElements.get('sticky-add-to-cart')) {
  customElements.define(
    'sticky-add-to-cart',
    class StickyAddToCart extends HTMLElement {
      connectedCallback() {
        // The quick add modal renders the main product section too; the bar doesn't belong there.
        if (this.closest('quick-add-modal')) {
          this.remove();
          return;
        }

        // Live directly under <body> so no transformed ancestor breaks position: fixed.
        if (this.parentElement !== document.body) {
          document.querySelectorAll('body > sticky-add-to-cart').forEach((bar) => bar.remove());
          document.body.appendChild(this);
          return;
        }

        if (this.initialized) return;
        this.initialized = true;

        this.form = document.getElementById(this.dataset.formId);
        this.button = this.querySelector('.sticky-atc__button');
        this.label = this.querySelector('.sticky-atc__label');
        this.price = this.querySelector('[data-sticky-atc-price]');
        this.spinner = this.button.querySelector('.loading__spinner');
        this.input = this.querySelector('.quantity__input');
        this.available = this.dataset.available === 'true';

        this.button.addEventListener('click', this.onButtonClick.bind(this));
        this.input.addEventListener('change', this.syncQuantityToForm.bind(this));

        this.mainQuantity = document.querySelector(`input[name="quantity"][form="${this.dataset.formId}"]`);
        if (this.mainQuantity) {
          this.copyQuantityRules();
          this.input.value = this.mainQuantity.value;
          this.onMainQuantityChange = () => {
            this.input.value = this.mainQuantity.value;
          };
          this.mainQuantity.addEventListener('change', this.onMainQuantityChange);
          this.quantityObserver = new MutationObserver(this.copyQuantityRules.bind(this));
          this.quantityObserver.observe(this.mainQuantity, { attributes: true, attributeFilter: ['min', 'max', 'step'] });
        }

        // Mirror the loading state of the main add to cart button.
        if (this.form) {
          this.formObserver = new MutationObserver(this.syncButtonState.bind(this));
          this.formObserver.observe(this.form, { attributes: true, subtree: true, attributeFilter: ['class'] });
        }

        if (typeof subscribe === 'function') {
          this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, this.onVariantChange.bind(this));
        }

        this.syncButtonState();
      }

      disconnectedCallback() {
        if (!this.initialized) return;
        this.initialized = false;
        this.formObserver?.disconnect();
        this.quantityObserver?.disconnect();
        this.variantChangeUnsubscriber?.();
        this.mainQuantity?.removeEventListener('change', this.onMainQuantityChange);
      }

      get mainButton() {
        return this.form?.querySelector('[type="submit"][name="add"]');
      }

      copyQuantityRules() {
        ['min', 'max', 'step'].forEach((attribute) => {
          const value = this.mainQuantity.getAttribute(attribute);
          if (value === null) {
            this.input.removeAttribute(attribute);
          } else {
            this.input.setAttribute(attribute, value);
          }
        });
        this.input.dataset.min = this.mainQuantity.dataset.min || this.input.min;
        if (this.mainQuantity.dataset.max) {
          this.input.dataset.max = this.mainQuantity.dataset.max;
        } else {
          delete this.input.dataset.max;
        }
      }

      syncQuantityToForm() {
        if (!this.form) return;
        if (this.mainQuantity) {
          if (this.mainQuantity.value !== this.input.value) {
            this.mainQuantity.value = this.input.value;
            this.mainQuantity.dispatchEvent(new Event('change', { bubbles: true }));
          }
          return;
        }

        // The page has no quantity selector block: send the quantity with a hidden input.
        if (!this.hiddenQuantity) {
          this.hiddenQuantity = document.createElement('input');
          this.hiddenQuantity.type = 'hidden';
          this.hiddenQuantity.name = 'quantity';
          this.form.appendChild(this.hiddenQuantity);
        }
        this.hiddenQuantity.value = this.input.value;
      }

      onButtonClick() {
        const mainButton = this.mainButton;
        if (!this.available || !mainButton || mainButton.classList.contains('loading')) return;
        this.syncQuantityToForm();
        // product-form intercepts the submit, adds to cart and opens the cart drawer.
        mainButton.click();
      }

      onVariantChange({ data }) {
        if (data.sectionId !== this.dataset.sectionId) return;
        this.available = Boolean(data.variant && data.variant.available);
        this.variantExists = Boolean(data.variant);
        const newPrice = data.html?.querySelector('[data-sticky-atc-price]');
        if (newPrice) this.price.textContent = newPrice.textContent;
        this.syncButtonState();
      }

      syncButtonState() {
        const loading = Boolean(this.mainButton?.classList.contains('loading'));
        this.button.classList.toggle('loading', loading);
        this.spinner?.classList.toggle('hidden', !loading);

        this.button.disabled = !this.available;
        if (this.available) {
          this.label.textContent = this.dataset.addToCartText;
        } else {
          this.label.textContent =
            this.variantExists === false ? this.dataset.unavailableText : this.dataset.soldOutText;
        }
        this.price.hidden = this.variantExists === false;
      }
    }
  );
}
